/**
 * Generated file
 * Do not edit directly
 */

export const COLOR_BRAND_NEON = '#94F477';
export const COLOR_BRAND_NEON_DARK = '#6ADD36';
export const COLOR_BRAND_ONYX = '#161f13';
export const COLOR_BRAND_PINE = '#1B2818';
export const COLOR_BRAND_LAVENDER = '#D3CBE5';
export const COLOR_BRAND_DUSK = '#9889B3';
export const COLOR_BRAND_FOG = '#DCE1DB';
export const COLOR_BRAND_MOSS = '#7D867C';
export const COLOR_BRAND_SAND = '#C1AF98';
export const COLOR_BRAND_BIRCH = '#F2EEE7';
export const COLOR_NEUTRAL_50 = '#fafafa';
export const COLOR_NEUTRAL_100 = '#f4f5f4';
export const COLOR_NEUTRAL_200 = '#e6eae6';
export const COLOR_NEUTRAL_300 = '#d0d6ce';
export const COLOR_NEUTRAL_400 = '#aab3a9';
export const COLOR_NEUTRAL_500 = '#8b958a';
export const COLOR_NEUTRAL_600 = '#6b746a';
export const COLOR_NEUTRAL_700 = '#535b52';
export const COLOR_NEUTRAL_800 = '#343933';
export const COLOR_NEUTRAL_900 = '#222621';
export const COLOR_NEUTRAL_950 = '#151915';
export const COLOR_NEUTRAL_1000 = '#0E110E';
export const COLOR_NEUTRAL_WHITE = '#ffffff';
export const COLOR_NEUTRAL_BLACK = '#000000';
export const COLOR_NEUTRAL_TRANSPARENT = 'rgba(0, 0, 0, 0.0)';
export const COLOR_NEUTRAL_50_A = 'rgba(17, 23, 14, 0.03)';
export const COLOR_NEUTRAL_100_A = 'rgba(17, 23, 14, 0.06)';
export const COLOR_NEUTRAL_200_A = 'rgba(17, 23, 14, 0.1)';
export const COLOR_NEUTRAL_300_A = 'rgba(17, 23, 14, 0.18)';
export const COLOR_NEUTRAL_400_A = 'rgba(17, 23, 14, 0.33)';
export const COLOR_NEUTRAL_500_A = 'rgba(17, 23, 14, 0.46)';
export const COLOR_NEUTRAL_600_A = 'rgba(17, 23, 14, 0.61)';
export const COLOR_NEUTRAL_700_A = 'rgba(17, 23, 14, 0.71)';
export const COLOR_NEUTRAL_800_A = 'rgba(17, 23, 14, 0.86)';
export const COLOR_NEUTRAL_900_A = 'rgba(17, 23, 14, 0.92)';
export const COLOR_GREEN_100 = '#eef7ed';
export const COLOR_GREEN_200 = '#d8f5d4';
export const COLOR_GREEN_300 = '#99e68a';
export const COLOR_GREEN_400 = '#70C55C';
export const COLOR_GREEN_500 = '#4DA330';
export const COLOR_GREEN_600 = '#458134';
export const COLOR_GREEN_700 = '#375c2d';
export const COLOR_GREEN_800 = '#293E23';
export const COLOR_GREEN_900 = '#1B2818';
export const COLOR_GREEN_950 = '#161f13';
export const COLOR_GREEN_BASE = '#4DA330';
export const COLOR_RED_100 = '#FDF1ED';
export const COLOR_RED_200 = '#FAE4DF';
export const COLOR_RED_300 = '#FDAA9B';
export const COLOR_RED_400 = '#F29379';
export const COLOR_RED_500 = '#E9653A';
export const COLOR_RED_600 = '#BA4C21';
export const COLOR_RED_700 = '#853B20';
export const COLOR_RED_800 = '#572918';
export const COLOR_RED_900 = '#361D14';
export const COLOR_RED_BASE = '#E9653A';
export const COLOR_BLUE_100 = '#EEF6FE';
export const COLOR_BLUE_200 = '#DBEAFD';
export const COLOR_BLUE_300 = '#BCD6FC';
export const COLOR_BLUE_400 = '#81B0FB';
export const COLOR_BLUE_500 = '#4C8BF9';
export const COLOR_BLUE_600 = '#3A70C6';
export const COLOR_BLUE_700 = '#30538B';
export const COLOR_BLUE_800 = '#23385A';
export const COLOR_BLUE_900 = '#18253A';
export const COLOR_BLUE_BASE = '#4C8BF9';
export const COLOR_YELLOW_100 = '#FEF4E4';
export const COLOR_YELLOW_200 = '#FCE8C6';
export const COLOR_YELLOW_300 = '#FACC70';
export const COLOR_YELLOW_400 = '#EDB326';
export const COLOR_YELLOW_500 = '#BB8A15';
export const COLOR_YELLOW_600 = '#926922';
export const COLOR_YELLOW_700 = '#6D4E1E';
export const COLOR_YELLOW_800 = '#493415';
export const COLOR_YELLOW_900 = '#2F2312';
export const COLOR_YELLOW_BASE = '#EDB326';
export const COLOR_PURPLE_100 = '#f7f3fd';
export const COLOR_PURPLE_200 = '#efe5fb';
export const COLOR_PURPLE_300 = '#dec9f6';
export const COLOR_PURPLE_400 = '#c399ef';
export const COLOR_PURPLE_500 = '#ac7adf';
export const COLOR_PURPLE_600 = '#8858bb';
export const COLOR_PURPLE_700 = '#64448a';
export const COLOR_PURPLE_800 = '#412e5a';
export const COLOR_PURPLE_900 = '#2a1f3b';
export const COLOR_PURPLE_BASE = '#ac7adf';
export const COLOR_ORANGE_100 = '#FFF3EB';
export const COLOR_ORANGE_300 = '#F8BC98';
export const COLOR_ORANGE_400 = '#F8903C';
export const COLOR_ORANGE_BASE = '#F8903C';
export const COLOR_JADE_100 = '#e8fdf0';
export const COLOR_JADE_200 = '#c4fbdb';
export const COLOR_JADE_300 = '#6ee4a7';
export const COLOR_JADE_400 = '#4cc28b';
export const COLOR_JADE_500 = '#2aa372';
export const COLOR_JADE_600 = '#227d59';
export const COLOR_JADE_700 = '#195e44';
export const COLOR_JADE_800 = '#133e2e';
export const COLOR_JADE_900 = '#142820';
export const COLOR_JADE_950 = '#121915';
export const COLOR_TEAL_100 = '#f0fafb';
export const COLOR_TEAL_200 = '#cff2f5';
export const COLOR_TEAL_300 = '#9be3e9';
export const COLOR_TEAL_400 = '#57bcc4';
export const COLOR_TEAL_500 = '#329ea5';
export const COLOR_TEAL_600 = '#007b81';
export const COLOR_TEAL_700 = '#165c60';
export const COLOR_TEAL_800 = '#143d3f';
export const COLOR_TEAL_900 = '#102829';
export const COLOR_PINK_100 = '#fcf2f5';
export const COLOR_PINK_200 = '#f9e4ea';
export const COLOR_PINK_300 = '#f4c6d4';
export const COLOR_PINK_400 = '#ed93b2';
export const COLOR_PINK_500 = '#e96098';
export const COLOR_PINK_600 = '#c83979';
export const COLOR_PINK_700 = '#8d315f';
export const COLOR_PINK_800 = '#592441';
export const COLOR_PINK_900 = '#381a2c';
export const COLOR_PLUS_100 = '#EBEEFF';
export const COLOR_PLUS_200 = '#E2EBFB';
export const COLOR_PLUS_500 = '#6395E9';
export const COLOR_PLUS_600 = '#3F6CB2';
export const COLOR_PLUS_900 = '#1B2539';
export const COLOR_PEAK_200 = '#EFE7FE';
export const COLOR_PEAK_400 = '#C09AFB';
export const COLOR_PEAK_500 = '#AC76F6';
export const COLOR_PEAK_600 = '#8051C2';
export const COLOR_PEAK_900 = '#2A203A';
export const COLOR_DEPRECATED = '#FF11EF'; // Internal use only
export const COLOR_TEXT_PRIMARY = '#161f13';
export const COLOR_TEXT_PRIMARY_HOVER = '#343933';
export const COLOR_TEXT_SECONDARY = '#535b52';
export const COLOR_TEXT_SECONDARY_HOVER = '#6b746a';
export const COLOR_TEXT_TERTIARY = '#8b958a';
export const COLOR_TEXT_PRIMARY_INVERSE = '#ffffff';
export const COLOR_TEXT_INVERSE_HOVER = '#f4f5f4';
export const COLOR_TEXT_DISABLED = '#d0d6ce';
export const COLOR_TEXT_PLACEHOLDER = '#535b52';
export const COLOR_TEXT_ERROR = '#BA4C21';
export const COLOR_TEXT_SUCCESS = '#375c2d';
export const COLOR_TEXT_CAUTION = '#926922';
export const COLOR_TEXT_INFO = '#30538B';
export const COLOR_TEXT_PLUS = '#3F6CB2';
export const COLOR_TEXT_PEAK = '#8051C2';
export const COLOR_TEXT_LIGHT = '#ffffff';
export const COLOR_TEXT_LIGHT_SECONDARY = 'rgba(255, 255, 255, 0.6)';
export const COLOR_TEXT_DARK = '#161f13';
export const COLOR_TEXT_LINK_PRIMARY = '#161f13'; // deprecate, use text tokens instead
export const COLOR_TEXT_LINK_PRIMARY_HOVER = '#343933';
export const COLOR_TEXT_LINK_SECONDARY = '#161f13'; // deprecate, use text tokens instead
export const COLOR_TEXT_LINK_INVERSE = '#ffffff'; // deprecate, use text tokens instead
export const COLOR_TEXT_LINK_INVERSE_HOVER = '#f4f5f4'; // deprecate, use text tokens instead
export const COLOR_BACKGROUND_PRIMARY = '#ffffff';
export const COLOR_BACKGROUND_PRIMARY_HOVER = '#fafafa';
export const COLOR_BACKGROUND_SECONDARY = '#f4f5f4';
export const COLOR_BACKGROUND_SECONDARY_HOVER = '#e6eae6';
export const COLOR_BACKGROUND_TERTIARY = '#e6eae6';
export const COLOR_BACKGROUND_TERTIARY_HOVER = '#d0d6ce';
export const COLOR_BACKGROUND_ELEVATED = '#ffffff';
export const COLOR_BACKGROUND_ACCENT = '#94F477';
export const COLOR_BACKGROUND_ACCENT_HOVER = '#6ADD36';
export const COLOR_BACKGROUND_DISABLED = '#f4f5f4';
export const COLOR_BACKGROUND_PLUS = '#E2EBFB';
export const COLOR_BACKGROUND_PEAK = '#EFE7FE';
export const COLOR_BACKGROUND_SUCCESS_WEAK = '#eef7ed';
export const COLOR_BACKGROUND_SUCCESS_BASE = '#4DA330';
export const COLOR_BACKGROUND_SUCCESS_STRONG = '#458134';
export const COLOR_BACKGROUND_ERROR_WEAK = '#FDF1ED';
export const COLOR_BACKGROUND_ERROR_BASE = '#E9653A';
export const COLOR_BACKGROUND_ERROR_STRONG = '#BA4C21';
export const COLOR_BACKGROUND_CAUTION_WEAK = '#FEF4E4';
export const COLOR_BACKGROUND_CAUTION_BASE = '#EDB326';
export const COLOR_BACKGROUND_CAUTION_STRONG = '#926922';
export const COLOR_BACKGROUND_INFO_WEAK = '#EEF6FE';
export const COLOR_BACKGROUND_INFO_BASE = '#4C8BF9';
export const COLOR_BACKGROUND_INFO_STRONG = '#3A70C6';
export const COLOR_BACKGROUND_INVERSE = '#161f13'; // this should replace bg primary inverse overlay
export const COLOR_BACKGROUND_TINTED = 'rgba(17, 23, 14, 0.1)';
export const COLOR_BACKGROUND_BRAND_BIRCH = '#F2EEE7';
export const COLOR_BACKGROUND_BRAND_SAND = '#C1AF98';
export const COLOR_BACKGROUND_BRAND_LAVENDER = '#D3CBE5';
export const COLOR_BORDER_SEPARATOR = 'rgba(17, 23, 14, 0.1)';
export const COLOR_BORDER_INTERACTIVE = 'rgba(17, 23, 14, 0.18)';
export const COLOR_BORDER_ACTIVE = '#161f13';
export const COLOR_BORDER_INTERACTIVE_HOVER = '#aab3a9';
export const COLOR_BORDER_DISABLED = 'rgba(17, 23, 14, 0.1)';
export const COLOR_BORDER_ERROR = '#BA4C21';
export const COLOR_BORDER_FOCUS_PRIMARY = '#4C8BF9'; // deprecating, use focus-default
export const COLOR_BORDER_FOCUS_DEFAULT = '#4C8BF9';
export const COLOR_SHADOW = 'rgba(0, 0, 0, 0.3)';
export const COLOR_INTERACTIVE_ACCENT = '#161f13'; // interactive items that become neon in dark mode
export const COLOR_INTERACTIVE_PRIMARY = '#161f13';
export const COLOR_INTERACTIVE_ACCENT_HOVER = '#343933';
export const COLOR_INTERACTIVE_PRIMARY_HOVER = '#343933';
export const COLOR_DIFFICULTY_EASY = '#4DA330';
export const COLOR_DIFFICULTY_MODERATE = '#EDB326';
export const COLOR_DIFFICULTY_HARD = '#E9653A';
export const COLOR_DIFFICULTY_STRENUOUS = '#572918';
export const COLOR_UV_1 = '#99e68a';
export const COLOR_UV_2 = '#FACC70';
export const COLOR_UV_3 = '#F8903C';
export const COLOR_UV_4 = '#E9653A';
export const COLOR_UV_5 = '#ac7adf';
export const COLOR_BADGE_COMPLETE = '#343933';
export const COLOR_BADGE_VERIFIED = '#343933';
export const COLOR_MAP_ROUTE = '#94F477'; // Represents AllTrails specified route information, like route polyline, route elevation etc
export const COLOR_MAP_ROUTE_OUTLINE = '#375c2d'; // border for route
export const COLOR_MAP_ACTIVITY = '#219AD8'; // Represents users activity data, like the path a user has taken during an activity
export const COLOR_MAP_ACTIVITY_OUTLINE = '#24505E'; // Custom color. Border for activity
export const COLOR_MAP_WAYPOINT_VERIFIED = '#007b81';
export const COLOR_MAP_WAYPOINT_USER = '#329ea5';
export const COLOR_MAP_WAYPOINT_PHOTO = '#A581B1';
export const COLOR_MAP_CUSTOM_ROUTE_1 = '#65DDE1';
export const COLOR_MAP_CUSTOM_ROUTE_2 = '#7D76FF';
export const COLOR_MAP_CUSTOM_ROUTE_3 = '#AB7EE5';
export const COLOR_MAP_CUSTOM_ROUTE_4 = '#EDB326';
export const COLOR_MAP_CUSTOM_ROUTE_1_OUTLINE = '#195C5D';
export const COLOR_MAP_CUSTOM_ROUTE_2_OUTLINE = '#454276';
export const COLOR_MAP_CUSTOM_ROUTE_3_OUTLINE = '#4F3A64';
export const COLOR_MAP_CUSTOM_ROUTE_4_OUTLINE = '#7B510A';
export const COLOR_MAP_POI = '#eef7ed'; // when a trail intersects a POI
export const COLOR_MAP_POI_OUTLINE = '#375c2d'; // Border for POI
export const COLOR_MAP_CONDITION_OUTLINE = '#000000'; // Border for polyline with conditions overlay
export const COLOR_CONDITIONS_GRASS = '#85b767';
export const COLOR_CONDITIONS_WOOD = '#805c5c';
export const COLOR_CONDITIONS_NATURAL = '#af8657';
export const COLOR_CONDITIONS_SAND = '#e5bf79';
export const COLOR_CONDITIONS_GRAVEL = '#d4d2bf';
export const COLOR_CONDITIONS_ROCK = '#8a8783';
export const COLOR_CONDITIONS_PAVED = '#555f52';
export const COLOR_CONDITIONS_METAL = '#acbec3';
export const COLOR_CONDITIONS_SNOW = '#92d8f5';
export const COLOR_CONDITIONS_PLASTIC = '#6174cb';
export const COLOR_CONDITIONS_RUBBER = '#9258ae';
export const COLOR_CONDITIONS_STEPS = '#c25c5b';
export const COLOR_CONDITIONS_UNKNOWN = '#f4f5f4';
export const COLOR_DATAVIZ_1 = '#3571CA';
export const COLOR_DATAVIZ_HEATMAPS_1 = 'rgba(231, 83, 253, 0.2)';
export const COLOR_DATAVIZ_HEATMAPS_2 = 'rgba(231, 83, 253, 0.3)';
export const COLOR_DATAVIZ_HEATMAPS_3 = 'rgba(231, 83, 253, 0.6)';
export const COLOR_DATAVIZ_HEATMAPS_4 = 'rgba(171, 70, 251, 0.7)';
export const COLOR_DATAVIZ_HEATMAPS_5 = 'rgba(113, 57, 249, 0.8)';
export const COLOR_DATAVIZ_PUBLIC_LANDS_BLM = '#e6c84f'; // BLM - Bureau of Land Management
export const COLOR_DATAVIZ_PUBLIC_LANDS_USFS = '#43a047'; // USFS - U.S. Forest Service
export const COLOR_DATAVIZ_PUBLIC_LANDS_FWS = '#2c7fb8'; // FWS - Fish and Wildlife Service
export const COLOR_DATAVIZ_PUBLIC_LANDS_NPS = '#8b5a2b'; // NPS - National Park Service
export const COLOR_DATAVIZ_PUBLIC_LANDS_DOD = '#6b7280'; // DOD - Department of Defense
export const COLOR_DATAVIZ_PUBLIC_LANDS_USACE = '#4db6ac'; // USACE - U.S. Army Corps of Engineers
export const COLOR_DATAVIZ_PUBLIC_LANDS_USBR = '#a6cee3'; // USBR - U.S. Bureau of Reclamation
export const COLOR_DATAVIZ_PUBLIC_LANDS_STATE_PARKS_AND_REC = '#6ac96e'; // State parks and recreation agency
export const COLOR_DATAVIZ_PUBLIC_LANDS_STATE_DNR = '#aed581'; // State department of natural resources
export const COLOR_DATAVIZ_PUBLIC_LANDS_REGIONAL_AGENCY = '#f3dfb8';
export const COLOR_DATAVIZ_PUBLIC_LANDS_COUNTY_AGENCY = '#e5bf79';
export const COLOR_DATAVIZ_PUBLIC_LANDS_CITY_LAND = '#c4ae6c';
export const COLOR_DATAVIZ_PUBLIC_LANDS_NATIVE_AMERICAN_ALASKA_NATIVE_LAND = '#b39ddb';
export const COLOR_DATAVIZ_PUBLIC_LANDS_NGO = '#90a4ae'; // NGO - Non-governmental organization
export const COLOR_DATAVIZ_SLOPE_1 = '#ADFF2F';
export const COLOR_DATAVIZ_SLOPE_2 = '#FFFF00';
export const COLOR_DATAVIZ_SLOPE_3 = '#FFA500';
export const COLOR_DATAVIZ_SLOPE_4 = '#FF4500';
export const COLOR_DATAVIZ_SLOPE_5 = '#DC0000';
export const COLOR_DATAVIZ_SLOPE_6 = '#800080';
export const COLOR_DATAVIZ_SLOPE_7 = '#0000FF';
export const COLOR_DATAVIZ_SLOPE_8 = '#000000';
export const COLOR_SCRIM_LIGHT = 'rgba(0, 0, 0, 0.4)';
export const COLOR_SCRIM_DARK = 'rgba(0, 0, 0, 0.7)';
export const COLOR_VENDOR_FACEBOOK = '#1877F2';
export const COLOR_VENDOR_GOOGLE = '#3073df';
export const COLOR_VENDOR_APPLE = '#000000';
export const GUIDE_BLACKFOREST_BACKGROUND = '#161f13';
export const GUIDE_BLACKFOREST_BLOCKQUOTE = '#eef7ed';
export const GUIDE_EVERGREEN_BACKGROUND = '#1B2818';
export const GUIDE_EVERGREEN_BLOCKQUOTE = '#eef7ed';
export const GUIDE_MAROON_BACKGROUND = '#221511';
export const GUIDE_MAROON_BLOCKQUOTE = '#FAE4DF';
export const GUIDE_BROWN_BACKGROUND = '#2F2312';
export const GUIDE_BROWN_BLOCKQUOTE = '#FCE8C6';
export const GUIDE_GOLDENROD_BACKGROUND = '#6D4E1E';
export const GUIDE_GOLDENROD_BLOCKQUOTE = '#FEF4E4';
export const GUIDE_REDWOOD_BACKGROUND = '#572918';
export const GUIDE_REDWOOD_BLOCKQUOTE = '#FDF1ED';
export const GUIDE_MIDNIGHT_BACKGROUND = '#121720';
export const GUIDE_MIDNIGHT_BLOCKQUOTE = '#EEF6FE';
